import { Directive, inject, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthService } from '@core/services/api/auth.service';

@Directive({
    selector: '[hasRole]',
    standalone: true,
})
export class HasRoleDirective {
    private tpl = inject(TemplateRef);
    private vcr = inject(ViewContainerRef);
    private auth = inject(AuthService);

    @Input() set hasRole(role: string | string[]) {
        this.vcr.clear();
        if (this.auth.hasAnyRole(role)) {
            this.vcr.createEmbeddedView(this.tpl);
        }
    }
}
